module.exports = __webpack_public_path__ + "images/wechat/leave-request-check-885708477bea10689d1a8eadabb100e7.png";